module.exports = __webpack_public_path__ + "static/img/bg-title.8d552d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg-title.png
// module id = 570
// module chunks = 4 5